"use client"

import { Button } from "@ui/shad"

import { useOrganizationImpersonation } from "@/hooks/api/organizations/impersonations"

export function ImpersonationBanner() {
  const { isImpersonating, userName, stop } = useOrganizationImpersonation()
  if (!isImpersonating) return null

  return (
    <div
      role="status"
      className="bg-yellow-background text-foreground border-yellow-border fixed bottom-4 left-1/2 z-[100] flex -translate-x-1/2 items-center justify-center gap-4 rounded-lg border-b px-4 py-2 shadow-sm"
    >
      <span className="text-sm">
        Viewing as <strong>{userName}</strong>
      </span>
      <Button size="sm" variant="outline" disabled={stop.isPending} onClick={() => stop.mutate()}>
        {stop.isPending ? "Signing out…" : "Stop impersonating"}
      </Button>
    </div>
  )
}
